export const INVOICE_STATUS = {
  '1': '待开票',
  '2': '申请中',
  '3': '审核不通过',
  '4': '已开票'
}

export const INVOICE_DETAIL_STATUS = {
  '1': '审核中',
  '2': '审核拒绝',
  '3': '审核通过'
}

export const INVOICE_COLOR = {
  '1': '待开票',
  '2': '#FF9900',
  '3': '#FF0000',
  '4': '#008000'
}

export const DETAIL_STATUS_COLOR = {
  '1': '#FF9900',
  '2': '#FF0000',
  '3': '#008000'
}

export const INVOICE_KIND = {
  '1': '普通电子发票',
  '2': '增值税专用发票'
}
